module.exports = __webpack_public_path__ + "static/media/logout.09eb23b3.svg";